import { createRoutine } from 'redux-saga-routines';

export const roadGraphGetSegmentsRoutine = createRoutine('ROAD_GRAPH/GET_SEGMENTS');

export const roadGraphSetSegmentRoutine = createRoutine('ROAD_GRAPH/SET_SEGMENT');
